import { render, staticRenderFns } from "./TeacherProfile.vue?vue&type=template&id=a4f4ec20&scoped=true&"
import script from "./TeacherProfile.vue?vue&type=script&lang=js&"
export * from "./TeacherProfile.vue?vue&type=script&lang=js&"
import style0 from "./TeacherProfile.vue?vue&type=style&index=0&id=a4f4ec20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f4ec20",
  null
  
)

export default component.exports